/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable object-curly-newline */
/* eslint-disable arrow-parens */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from 'react';
import { MdCheck, MdFlag } from 'react-icons/md';
import { FiCode } from 'react-icons/fi';
import { useSelector } from 'react-redux';
import Lottie from 'react-lottie';

// import history from '~/services/history';
import empty from '~/assets/animations/empty.json';
import pending from '~/assets/images/pending.png';
import wrong from '~/assets/images/wrong.png';
import correct from '~/assets/images/correct.png';
import Acerto from '~/assets/images/acerto.png';
import Revisao from '~/assets/images/revisao.png';
import Erro from '~/assets/images/erro.png';
import All from '~/assets/images/all.png';

import CorrectModal from '~/components/Correct';
import WrongModal from '~/components/Wrong';

import api from '~/services/api';
import { Container, Header, Body, Card, Summary } from './styles';

export default function Scorecard() {
  const user = useSelector((state) => state.user.profile);
  const [modules, setModules] = useState([]);
  const [scorecard, setScorecard] = useState('');
  const [correctModal, setCorrectModal] = useState(false);
  const [wrongModal, setWrongModal] = useState(false);
  const [id, setId] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
    async function getData() {
      const { data } = await api.get('/conquers');

      setModules(data);
    }

    async function getDataScorecard() {
      const { data } = await api.get(`students/${user.id}/scorecards`);

      setScorecard(data);
    }

    getData();
    getDataScorecard();
  }, [user]);

  function correctModalFunc(module) {
    setCorrectModal(true);
    setId(module.id);
  }

  function wrongModalFunc(module) {
    setWrongModal(true);
    setId(module.id);
  }

  return (
    <>
      {wrongModal ? (
        <WrongModal closeModal={() => setWrongModal(false)} id={id} />
      ) : null}

      {correctModal ? (
        <CorrectModal closeModal={() => setCorrectModal(false)} id={id} />
      ) : null}

      <Header>
        <p
          style={{
            fontSize: 26,
            paddingLeft: 40,
            color: '#36DED6',
            fontWeight: 'bold',
          }}
        >
          Meus desafios
        </p>
      </Header>

      <Summary>
        <div className="challenges">
          <p
            style={{
              color: '#fff',
              marginLeft: 14,
              marginTop: 10,
              marginBottom: 5,
            }}
          >
            STATUS DOS DESAFIOS
          </p>
          <div className="support-scorecard">
            <div className="scorecard">
              <div className="flag">
                <MdFlag size={30} color="#fff" />
                <h1 style={{ marginLeft: 10 }}>STATUS</h1>
              </div>
            </div>
            <div className="detail" style={{ marginLeft: 30 }}>
              <div className="image">
                <img src={Acerto} alt="acerto.png" />
              </div>
              <div className="subDetail">
                <div className="n">
                  <p className="number"> {scorecard.correct}</p>
                  <div>
                    <p style={{ fontSize: 14 }}>STATUS</p>
                    <p style={{ color: '#fff' }}>ACERTOS</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="detail">
              <div className="image">
                <img src={Revisao} alt="revisao.png" />
              </div>
              <div className="subDetail">
                <div className="n">
                  <p className="number"> {scorecard.processing}</p>
                  <div>
                    <p style={{ fontSize: 14 }}>STATUS</p>
                    <p style={{ color: '#fff' }}>REVISĀO</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="detail">
              <div className="image">
                <img src={Erro} alt="erro.png" />
              </div>

              <div className="subDetail">
                <div className="n">
                  <p className="number"> {scorecard.wrong}</p>
                  <div>
                    <p style={{ fontSize: 14 }}>STATUS</p>
                    <p style={{ color: '#fff' }}>ERROS</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="detail">
              <div className="image">
                <img src={All} alt="todos.png" />
              </div>
              <div className="subDetail">
                <div className="n">
                  <p className="number" style={{ fontSize: 25 }}>
                    {' '}
                    {scorecard.allUser}/{scorecard.all}
                  </p>
                  <div>
                    <p style={{ fontSize: 14 }}>STATUS</p>
                    <p style={{ color: '#fff' }}>TOTAL</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Summary>

      {modules.length === 0 ? (
        <>
          <Lottie
            options={{
              loop: true,
              autoplay: true,
              animationData: empty,
            }}
            height={450}
            width={450}
          />
          <p
            style={{
              color: '#fff',
              fontSize: 30,
              textAlign: 'center',
              width: 800,
              marginLeft: '20%',
              marginBottom: 180,
            }}
          >
            Você ainda nāo fez nenhum desafio, escolha um módulo, faça os
            desafios, e acompanhe seus resultados por aqui.
          </p>
        </>
      ) : (
        <Body>
          <div className="title">
            <img src={wrong} alt="wrong" />
            <p>Erros</p>
          </div>

          {scorecard.wrong === '0' ? (
            <p
              style={{
                color: '#fff',
                paddingLeft: 30,
                marginTop: 10,
                fontSize: 16,
              }}
            >
              Você nāo possui nenhum desafio para corrigir.
            </p>
          ) : null}
          <div className="wrong">
            {modules.map((module) => {
              if (module.status === 'wrong') {
                return (
                  // <Link
                  //   to={`feedback/${module.id}`}
                  //   params={module.id}
                  //   style={{
                  //     color: '#000',
                  //   }}
                  //   key={module.id}
                  // >
                  <Card onClick={() => wrongModalFunc(module)}>
                    <img
                      src={`${module.challenge.module.file.url}`}
                      alt="teste"
                    />
                    <div className="content">
                      <div>
                        <div className="bar" />
                        <p style={{ fontWeight: 'bold' }}>
                          {module.challenge.title}
                        </p>
                        <p style={{ fontSize: 10 }}>
                          {module.challenge.question}
                        </p>
                      </div>
                      <div className="icons">
                        <div>
                          <FiCode size={20} color="#090f35" />
                          <p
                            style={{
                              fontSize: 14,
                              fontWeight: 'bold',
                              color: '#090f35',
                              marginLeft: 2,
                            }}
                          >
                            CORRIGIR
                          </p>
                        </div>
                      </div>
                    </div>
                  </Card>
                  // </Link>
                );
              }
              return null;
            })}
          </div>

          <div className="title">
            <img src={pending} alt="pending" />
            <p>Revisāo</p>
          </div>
          {scorecard.processing === '0' ? (
            <p
              style={{
                color: '#fff',
                paddingLeft: 30,
                marginTop: 10,
                fontSize: 16,
              }}
            >
              Você nāo possui nenhum desafio em revisāo.
            </p>
          ) : null}
          <div className="pending">
            {modules.map((module) => {
              if (module.status === 'processing') {
                return (
                  <Card key={module.id} style={{ cursor: 'default' }}>
                    <img
                      src={`${module.challenge.module.file.url}`}
                      alt="teste"
                    />
                    <div className="content">
                      <div>
                        <div className="bar" />
                        <p style={{ fontWeight: 'bold' }}>
                          {module.challenge.title}
                        </p>
                        <p style={{ fontSize: 10 }}>
                          {module.challenge.question}
                        </p>
                      </div>
                      <div className="icons" />
                    </div>
                  </Card>
                );
              }
              return null;
            })}
          </div>

          <div className="title">
            <img src={correct} alt="correct" />
            <p>Acertos</p>
          </div>
          {scorecard.correct === '0' ? (
            <p
              style={{
                color: '#fff',
                paddingLeft: 30,
                marginTop: 10,
                fontSize: 16,
                marginBottom: 500,
              }}
            >
              Você nāo possui nenhum desafio válido ainda.
            </p>
          ) : null}
          <div className="correct">
            {modules.map((module) => {
              if (module.status === 'correct') {
                return (
                  // <Link
                  //   to={`answer/${module.id}`}
                  //   params={module.id}
                  //   style={{
                  //     color: '#000',
                  //   }}
                  //   key={module.id}
                  // >
                  <Card onClick={() => correctModalFunc(module)}>
                    <img
                      src={`${module.challenge.module.file.url}`}
                      alt="teste"
                    />
                    {/* <img
                      src={`https://api.apollopartners.com.br/files/${module.id}`}
                      alt={`module.${module.id}`}
                    /> */}
                    <div className="content">
                      <div>
                        <div className="bar" />
                        <p style={{ fontWeight: 'bold' }}>
                          {module.challenge.title}
                        </p>
                        <p style={{ fontSize: 10 }}>
                          {module.challenge.question}
                        </p>
                      </div>
                      <div className="icons">
                        <div>
                          <MdCheck size={20} color="#090f35" />
                          <p
                            style={{
                              fontSize: 14,
                              fontWeight: 'bold',
                              color: '#090f35',
                              marginLeft: 2,
                            }}
                          >
                            SUA RESPSOTA
                          </p>
                        </div>
                      </div>
                    </div>
                  </Card>
                  // </Link>
                );
              }
              return null;
            })}
          </div>
        </Body>
      )}

      <Container />
    </>
  );
}
